import Shop from '@/shop';
import _get from 'lodash/get';
import VKPixel from '@/extensions/vk/pixel';

function initVkExtension() {
  var isActive = _get(Shop.config.get('vk'), 'vk.pixel_active', false);

  if (isActive) {
    new VKPixel();
  }
}

document.addEventListener('DOMContentLoaded', initVkExtension);
